export default __webpack_public_path__ + "static/media/ElasticCache.3925bb9f.svg";